const initialState = {
  data: {
    size: 0,
    totalElements: 0,
    totalPages: 0,
    currentPage: 0,
    masterData: []
  },
  isLoading: false,
  hasErrored: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case '[MASTERDATA] HAS_ERRORED':
      return { ...state, isLoading: false, data: initialState.data, hasErrored: true };
    case '[MASTERDATA] IS_LOADING':
      return { ...state, hasErrored: false, data: initialState.data, isLoading: true };
    case '[MASTERDATA] FETCH_SUCCESS':
      return { ...state, hasErrored: false, isLoading: false, data: action.data };
    case '[MASTERDATABASE] HAS_ERRORED':
      return { ...state, isLoading: false, dataBase: initialState.data, hasErrored: true };
    case '[MASTERDATABASE] IS_LOADING':
      return { ...state, hasErrored: false, dataBase: initialState.data, isLoadingBase: true };
    case '[MASTERDATABASE] FETCH_SUCCESS':
      return { ...state, hasErrored: false, isLoadingBase: false, dataBase: action.dataBase };
    case '[MASTERDATABASE] FETCH_SUCCESS_CONTADOR':
      return { ...state, hasErrored: false, isLoading: false, contador: action.data };
    case '[MASTERDATA] COUNT_FAILS':
      return { ...state, countFails: action.countFails };
    default:
      return state;
  }
};
